import { gql } from '@apollo/client';

export const houseQuery = gql`
  query House($house_nr: Float, $lang: String) {
    allGebaeudes(lang: $lang, where: { house_nr: $house_nr }) {
      edges {
        node {
          image
          description
          name
          ort
          house_nr
        }
      }
    }
  }
`;
